import React, {useCallback} from 'react';
import {Collapse, Grid, Paper, TextField} from "@mui/material";
import clsx from "clsx";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import FilterListTwoToneIcon from "@mui/icons-material/FilterListTwoTone";
import CustomText from "../../../widgets/inputs/CustomText";
import {
    codFRegisterNone,
    emailRegisterNone,
    nomeRegisterNone,
    phoneRegisterPrivate
} from "../../../../utils/RegisterUtils";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {ContattaciStyle} from "../../../../styles/pages/contact/ContattaciStyle";
import {useFormContext} from "react-hook-form";

const SearchPaper = ({handleSearch, onSearch, open, setOpen, value}) => {
    const classes = BaseStyle();
    const contattaciClasses = ContattaciStyle();
    const {errors, register} = useFormContext();

    const handleKeyDown = useCallback((event) => {
        if ((event.ctrlKey && event.keyCode === 13) || event.keyCode === 13) {
            onSearch();
        }
    }, [onSearch])

    return (
        <Grid item xs={12}>
            <Paper
                className={clsx(classes.filterSearchPaper, classes.roundBorder)}
                component={"section"}>
                <TextField
                    placeholder={"Cerca per Codice fiscale, nome, cognome e molto altro"}
                    value={value}
                    onChange={handleSearch}
                    autoFocus={true}
                    fullWidth={true}
                    variant={"outlined"}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">
                            <Tooltip title={"Cerca"}>
                                <IconButton color="inherit" onClick={onSearch} size="large">
                                    <SearchTwoToneIcon/>
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>,
                        endAdornment: <InputAdornment position="start">
                            <Tooltip title={"Ricerca avanzata"}>
                                <IconButton
                                    color="inherit"
                                    onClick={() => setOpen(!open)}
                                    className={clsx(classes.expand, {
                                        [classes.expandOpen]: open,
                                    })}
                                    size="large">
                                    <FilterListTwoToneIcon/>
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>,
                        classes: {notchedOutline: contattaciClasses.noBorder},
                    }}
                />
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Grid container spacing={3} className={classes.padding2}>
                        <Grid item xs={12} sm={6}>
                            <CustomText
                                inputRef={register(codFRegisterNone)}
                                label={"Codice fiscale"}
                                autoFocus={open}
                                name={"search.codF"}
                                handleKeyDown={handleKeyDown}
                                error={errors["search"]?.["codF"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomText
                                inputRef={register(nomeRegisterNone)}
                                label={"Codice Identificativo"}
                                autoFocus={false}
                                name={"search.idSoggetto"}
                                handleKeyDown={handleKeyDown}
                                error={errors["search"]?.["idSoggetto"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomText
                                inputRef={register(nomeRegisterNone)}
                                label={"Nome"}
                                autoFocus={false}
                                name={"search.nome"}
                                handleKeyDown={handleKeyDown}
                                error={errors["search"]?.["nome"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomText
                                inputRef={register(nomeRegisterNone)}
                                label={"Cognome"}
                                autoFocus={false}
                                name={"search.cognome"}
                                handleKeyDown={handleKeyDown}
                                error={errors["search"]?.["cognome"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomText
                                inputRef={register(emailRegisterNone)}
                                label={"Email"}
                                autoFocus={false}
                                name={"search.email"}
                                handleKeyDown={handleKeyDown}
                                error={errors["search"]?.["email"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomText
                                inputRef={register(phoneRegisterPrivate)}
                                label={"Cellulare"}
                                autoFocus={false}
                                handleKeyDown={handleKeyDown}
                                name={"search.cell"}
                                error={errors["search"]?.["cell"]}
                            />
                        </Grid>
                    </Grid>
                </Collapse>
            </Paper>
        </Grid>
    );
};

export default React.memo(SearchPaper)
